import { createSharedValueKey } from './shared-values.model';
import { useSharedValue } from './use-shared-value';
import { useOnce } from '../use-once';
var SharedValueInitStatus;
(function (SharedValueInitStatus) {
    SharedValueInitStatus[SharedValueInitStatus["NotStarted"] = 0] = "NotStarted";
    SharedValueInitStatus[SharedValueInitStatus["Loading"] = 1] = "Loading";
    SharedValueInitStatus[SharedValueInitStatus["Error"] = 2] = "Error";
    SharedValueInitStatus[SharedValueInitStatus["Complete"] = 3] = "Complete";
})(SharedValueInitStatus || (SharedValueInitStatus = {}));
export function useSingletonInitialization(key, fetch, apply) {
    var statusKey = getStateKey(key);
    var state = useSharedValue(statusKey)[0];
    useOnce(initialize);
    function initialize() {
        if (state.status !== SharedValueInitStatus.NotStarted)
            return;
        try {
            state.status = SharedValueInitStatus.Loading; // Mindful mutation to gate concurrent inits.
            var response = fetch();
            if (isAsyncResponse(response)) {
                handleAsyncValue(response);
            }
            else {
                handleValue(response);
            }
        }
        catch (error) {
            handleError(error);
        }
    }
    function handleAsyncValue(response) {
        response.then(function (value) { return handleValue(value); }).catch(function (error) { return handleError(error); });
    }
    function handleValue(value) {
        state.status = SharedValueInitStatus.Complete;
        apply(value);
    }
    function handleError(error) {
        state.status = SharedValueInitStatus.Error;
        state.error = error;
    }
    function isAsyncResponse(response) {
        return !!response['then'];
    }
    var loading = state.status === SharedValueInitStatus.Loading || state.status === SharedValueInitStatus.NotStarted;
    return [loading, state.error];
}
function defaultState() {
    return { status: SharedValueInitStatus.NotStarted, error: undefined };
}
function getStateKey(key) {
    return createSharedValueKey("".concat(key.id, ":status"), defaultState());
}
//# sourceMappingURL=use-singleton-initialization.js.map